import { render } from "./edit_banks_form.vue?vue&type=template&id=927cb060&scoped=true"
import script from "./edit_banks_form.vue?vue&type=script&lang=js"
export * from "./edit_banks_form.vue?vue&type=script&lang=js"

import "./edit_banks_form.vue?vue&type=style&index=0&id=927cb060&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927cb060"]])

export default __exports__